import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { useState } from 'react';
import { useEffect } from 'react';
import { Button, TextField } from '@mui/material';
import { styled } from '@mui/system';
import { FaCheck } from "react-icons/fa";
import UpdateDialog from './UpdateModal';
import { getAgentDetails } from 'API/CspMapping/api';
import BackdropLoader from '../../General/Loader';
import { IoClose } from 'react-icons/io5';





const paginationModel = { page: 0, pageSize: 5 };


const StyledDataGrid = styled(DataGrid)(({ theme }) => ({

  '& .MuiDataGrid-columnHeaders': {
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    backgroundColor: theme.palette.background.default,
  },
  // '& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader': {
  //   '&:nth-of-type(1)': {
  //     position: 'sticky',
  //     left: 0,
  //     backgroundColor: theme.palette.background.default,
  //     zIndex: 100,
  //   },
  //   '&:nth-of-type(2)': {
  //     position: 'sticky',
  //     left: 200,
  //     backgroundColor: theme.palette.background.default,
  //     zIndex: 100,
  //   },
  //   '&:nth-of-type(3)': {
  //     position: 'sticky',
  //     left: 330,
  //     backgroundColor: theme.palette.background.default,
  //     zIndex: 100,
  //   },
  // },
}));



export default function UnMappedAgentTable(props) {
  const [row, setRow] = useState([])
  const [Amount, setAmount] = useState({})

  const [OpenUpdateModal, setUpdateModal] = useState(false)
  const [SelectedData, setSelectedData] = useState(null)
  const [UpdatedData, setUpdatedData] = useState({})

  const [AgentData, setAgentData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [SelectedDevices, setSelectedDevices] = useState([])

  const handleInputChange = (event, params) => {
    // console.log("event",event,params);
    if (/^[0-9]*$/.test(event.target.value)) {
      const userId = params.row.user_id;
      const newAmount = event.target.value ? parseInt(event.target.value) : "";
      setAmount((prevAmount) => ({
        ...prevAmount,
        [userId]: {
          ...prevAmount[userId],
          sh_amount: newAmount
        }
      }));
    }
  }

  const handleDiscountInputChange = (event, params) => {
    if (/^[0-9]*$/.test(event.target.value)) {
      const userId = params.row.hardware_id;
      const newAmount = event.target.value ? parseInt(event.target.value) : "";
      setAmount((prevAmount) => ({
        ...prevAmount,
        [userId]: {
          ...prevAmount[userId],
          rm_discount: newAmount
        }
      }));
      let SelectedData = SelectedDevices.find((item) => item.hardware_id === params.row.hardware_id)
      let RemainingData = SelectedDevices.filter((item) => item.hardware_id !== params.row.hardware_id)
      if (SelectedData) {
        console.log("SelectedData", SelectedData);
        SelectedData["rm_discount"] = newAmount
        setSelectedDevices([...RemainingData, SelectedData])
      }

    }
  }

  // console.log("SelectedDevices",SelectedDevices);


  const handleUpdateRequestAmount = (row, value) => {
    // console.log("1");
    if (/^[0-9]*$/.test(value)) {
      // console.log("2");
      const userId = row.user_id;
      const newAmount = value === "" ? 0 : parseInt(value);
      if (newAmount !== "") {
        setUpdatedData((prevData) => ({
          ...prevData,
          [userId]: newAmount
        }))
      }
    }
    else {
      // console.log("3");
      setUpdatedData((prevData) => ({
        ...prevData,
        [row.user_id]: UpdatedData[row.user_id] ? UpdatedData[row.user_id] : 0
      }))
    }

  }

  const handleSeletctDevice = (row) => {
    setSelectedDevices([...SelectedDevices, { hardware_id: row.hardware_id, quantity: row.quantity }])
  }

  const handleRemoveSelectedDevice = (row) => {
    let copy = [...SelectedDevices]
    let filter = copy.filter((item) => item.hardware_id !== row.hardware_id)


    delete Amount[row.hardware_id]

    setSelectedDevices(filter)
  }

  useEffect(() => {
    props.setRmpostData(UpdatedData)
  }, [UpdatedData])


  // console.log("Amount3",Amount);

  const handleUpdateClose = () => {
    setUpdateModal(false)
    setSelectedData(null)
  }

  console.log("props at table", props);



  useEffect(() => {
    if (props.data) {
      setRow(props.data)
    }
  }, [props.data])



  useEffect(() => {
    props.setSelectedData(Amount)
  }, [Amount])


  useEffect(() => {
    props.setSelectedDevice(SelectedDevices)
  }, [SelectedDevices])

  const columns = [
    //   { field: 'id', headerName: 'ID', width: 70 },
    { field: 'bank_name', headerName: 'Bank Name', width: 200 },
    { field: 'name', headerName: 'Device', width: 130 },
    { field: 'brand_name', headerName: 'Brand', width: 130 },
    { field: 'model', headerName: 'Modal No', width: 130 },
    { field: 'quantity', headerName: 'Quantity', width: 130 },
    { field: 'amount', headerName: 'Price per unit', width: 200 },
    {
      field: 'sh_amount',
      headerName: 'Total Amount',
      width: 150,
      renderCell: (params) => (
        <TextField
          variant="outlined"
          value={
            params.row.amount * params.row.quantity
          }
          disabled={Amount[params.row.user_id] || Amount[params.row.user_id] === "" ? false : true}
          sx={{
            input: {
              backgroundColor: Amount[params.row.user_id] || Amount[params.row.user_id] === "" ? 'inherit' : "#f2f2f2"
            }
          }}
          size='small'
          onChange={(event) => handleInputChange(event, params)}
        />
      ),
    },
    {
      width: 150,
      renderCell: (params) => (
        sessionStorage.getItem("UserType") !== "cso" ?
          SelectedDevices.find((item) => item.hardware_id === params.row.hardware_id) ?
            <Button variant='contained' color='primary' sx={{ fontWeight: 800 }} onClick={() => handleRemoveSelectedDevice(params.row)}><IoClose /></Button>
            :
            <Button variant='outlined' onClick={() => handleSeletctDevice(params.row)}><FaCheck /></Button>
          :
          null

      ),
    },
  ];

  const columns2 = [
    //   { field: 'id', headerName: 'ID', width: 70 },
    { field: 'bank_name', headerName: 'Bank Name', width: 200 },
    { field: 'name', headerName: 'Device', width: 130 },
    { field: 'brand_name', headerName: 'Brand', width: 130 },
    { field: 'model', headerName: 'Modal No', width: 130 },
    { field: 'quantity', headerName: 'Quantity', width: 130 },
    { field: 'amount', headerName: 'Price per unit', width: 200 },
    {
      field: 'discount',
      headerName: 'Discount',
      width: 150,
      renderCell: (params) => (
        <TextField
          variant="outlined"
          value={
            sessionStorage.getItem("UserType") === "cso" || sessionStorage.getItem("UserType") === "ph" ||props.status!=='pending' ?
              params.row.rm_discount ? params.row.rm_discount : 0
              :
              Amount[params.row.hardware_id] ? Amount[params.row.hardware_id].rm_discount : ""
          }
          sx={{
            input: {
              backgroundColor: SelectedDevices.find((item) => item.hardware_id === params.row.hardware_id)&&sessionStorage.getItem("UserType") !== "ph" ? 'inherit' : "#f2f2f2"
            }
          }}
          disabled={SelectedDevices.find((item) => item.hardware_id === params.row.hardware_id)&&sessionStorage.getItem("UserType") !== "ph" ? false : true}
          size='small'
          onChange={(event) =>event.target.value<=(params.row.amount * params.row.quantity)? handleDiscountInputChange(event, params):null}
        />
      ),
    },
    {
      field: 'sh_amount',
      headerName: 'Total Amount',
      width: 150,
      renderCell: (params) => (
        <TextField
          variant="outlined"
          value={
            sessionStorage.getItem("UserType") === "cso" || sessionStorage.getItem("UserType") === "ph" ?
              eval((params.row.amount * params.row.quantity) - (params.row.rm_discount ? params.row.rm_discount : 0))
              :
              Amount[params.row.hardware_id] ? eval((params.row.amount * params.row.quantity) - Amount[params.row.hardware_id].rm_discount) : params.row.amount * params.row.quantity
          }
          disabled
          size='small'
          onChange={(event) => handleInputChange(event, params)}
        />
      ),
    },
    {
      width: 150,
      renderCell: (params) => (
        sessionStorage.getItem("UserType") !== "cso"  && props.status==='pending'?
          SelectedDevices.find((item) => item.hardware_id === params.row.hardware_id) ?
            <Button variant='contained' color='primary' sx={{ fontWeight: 800 }} onClick={() => handleRemoveSelectedDevice(params.row)}><IoClose /></Button>
            :
            <Button variant='outlined' onClick={() => handleSeletctDevice(params.row)}><FaCheck /></Button>
          :
          null
      ),
    },
  ];

  // console.log("Props at",props);

  useEffect(() => {
    if (props.userDetails) {

      getAgentDetails(props.userDetails.request_id, setAgentData, setIsLoading)
    }
  }, [props.userDetails])


  useEffect(() => {
    if (AgentData) {
      props.setAgentDetails(AgentData)
    }
  }, [AgentData])

  return (
    <Paper sx={{ height: 400, width: '100%' }}>
      <BackdropLoader open={isLoading} />
      <UpdateDialog updatedData={UpdatedData} handleUpdateData={handleUpdateRequestAmount} data={SelectedData} open={OpenUpdateModal} handleClose={handleUpdateClose} />
      {
        sessionStorage.getItem("UserType") === "ph" || sessionStorage.getItem("UserType") === "rm" || sessionStorage.getItem("UserType") === "cso" ?
          <StyledDataGrid
            rows={row && Array.isArray(row) && row.length > 0 ? row[0].hardware_data : []}
            columns={props.data && sessionStorage.getItem("UserType") === "ph" && !props.data[0].fwd_to_rm ? columns : columns2}
            initialState={{ pagination: { paginationModel } }}
            pageSizeOptions={[5, 10]}
            getRowId={(item) => item.hardware_id}
            sx={{ border: 0 }}
          />

          :
          null
      }

    </Paper>
  );
}
